/**
 * @flow
 * @relayHash f7f2b49e41bca187c40a20c2d943d4d7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type cancelHyeventInput = {|
  clientMutationId?: ?string,
  id: string,
  cancelReason?: ?string,
|};
export type cancelEventMutationVariables = {|
  input: cancelHyeventInput
|};
export type cancelEventMutationResponse = {|
  +cancelHyevent: ?{|
    +clientMutationId: ?string,
    +hyevent: ?{|
      +id: string,
      +title: string,
      +maxNoOfGuests: number,
      +additionalGuestAllowed: boolean,
      +maxAdditionalGuests: ?number,
      +ctaText: string,
      +messageTitle: string,
      +message: string,
      +address: string,
      +status: string,
      +propertyId: string,
      +startAt: any,
      +endAt: any,
      +publishAt: ?any,
      +cancelReason: ?string,
      +rsvpedCount: number,
    |},
  |}
|};
export type cancelEventMutation = {|
  variables: cancelEventMutationVariables,
  response: cancelEventMutationResponse,
|};
*/


/*
mutation cancelEventMutation(
  $input: cancelHyeventInput!
) {
  cancelHyevent(input: $input) {
    clientMutationId
    hyevent {
      id
      title
      maxNoOfGuests
      additionalGuestAllowed
      maxAdditionalGuests
      ctaText
      messageTitle
      message
      address
      status
      propertyId
      startAt
      endAt
      publishAt
      cancelReason
      rsvpedCount
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "cancelHyeventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "cancelHyevent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "cancelHyeventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "maxNoOfGuests",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "additionalGuestAllowed",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "maxAdditionalGuests",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "ctaText",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "messageTitle",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "address",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "propertyId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "startAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "endAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "publishAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cancelReason",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "rsvpedCount",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "cancelEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "cancelEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "cancelEventMutation",
    "id": null,
    "text": "mutation cancelEventMutation(\n  $input: cancelHyeventInput!\n) {\n  cancelHyevent(input: $input) {\n    clientMutationId\n    hyevent {\n      id\n      title\n      maxNoOfGuests\n      additionalGuestAllowed\n      maxAdditionalGuests\n      ctaText\n      messageTitle\n      message\n      address\n      status\n      propertyId\n      startAt\n      endAt\n      publishAt\n      cancelReason\n      rsvpedCount\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'caec307c1d4156f8756fc7fb3e5d6f46';
module.exports = node;
